// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_eq-6";
export var emphasizeQuantity = "_eq-3";
export var flatBottomCorners = "_eq-5";
export var productImage = "_eq-0";
export var quantityContainer = "_eq-2";
export var tooltip = "_eq-1";
export var wrapAndEllipsesOverflow = "_eq-4";